import {getCityFromLatLng} from "./serverUtility";

function isNotNull (val)  {
        return (!val == undefined || !val == "" || !val == null)
}
function isNotNullv2 (val)  {
    return (!(val == undefined) && !(val == "") && !(val == null))
}
function isSuccess (response)  {
    return (response.status == 200 && response.data.esito == "OK")
}

function addDays(timestamp, days) {
    var result = new Date(timestamp);
    result.setDate(result.getDate() + days);
    return result;
}
function subtractDays(timestamp, days) {

    var result = new Date(timestamp);
    result.setDate(result.getDate() - days);
    return result;
}
function convertTimeStamp(timestamp){

    let dateFormat= new Date(timestamp).toLocaleDateString('it-IT', { year:"numeric", month:"numeric", day:"numeric"})
    return dateFormat
}
const calcolaGiorni = (dataArrivo,dataPartenza) => {
    let giorni = [], date1 = dataArrivo;

    while(date1<dataPartenza){
        giorni.push(date1)
        date1 = new Date(date1)
        date1=date1.setDate(date1.getDate() + 1)
    }
    return giorni
}
function dateIsValid(date) {

    return !Number.isNaN(new Date(date).getTime());
}
function mostraPrezzo(item,mode){
    let prezzo = 0
    switch(mode) {
        case "totale":
            prezzo = item.costoTotale
            if(isNaN(parseInt(prezzo))){
                return ""
            }

            return new Intl.NumberFormat().format(prezzo)+"€"
            break;
        case "notte":
            prezzo = item.costoNotte


            if(isNaN(parseInt(prezzo))){
                return ""
            }


            return new Intl.NumberFormat().format(prezzo)+"€"+"/Notte"
            break;
        default:
            return ""
    }

}
async function getCity(latitudine,longitudine){
    let response = await getCityFromLatLng(latitudine,longitudine)
    let output = undefined
    let locality=undefined
    let provincia=undefined

    if(response.data != undefined &&
        response.data.results != undefined &&
        response.data.results[0] != undefined &&
        response.data.results[0].address_components != undefined) {

        response.data.results[0].address_components.map((result, index) => {
            if (result.types[0] === "locality") {
                locality = result.long_name
            } else if (result.types[0] === "administrative_area_level_2") {
                provincia = result.short_name
            }
        })

    }
    if(locality!=undefined && provincia != undefined){
        output=locality+" ("+provincia+")"
    }
    //console.log("output",output)
    return output
}
async function getLocazioni(rooms){
    let locazioni ={}
    for(let j=0;j<rooms.length;j++){
        //console.log(response.data.risultato.rooms[j].locazione)
        if(rooms!= undefined &&
            rooms[j]!=undefined &&
            rooms[j].locazione != undefined &&
            rooms[j].locazione.lat!=undefined &&
            rooms[j].locazione.long!=undefined
        ) {
            let googleresponse = await getCity(rooms[j].locazione.lat,rooms[j].locazione.long)
            //console.log("google response",googleresponse)
            if (rooms[j].id != undefined && googleresponse!=undefined)
                locazioni[rooms[j].id] = googleresponse
        }
    }
    return locazioni
    //console.log("locazioni",locazioni)
}
function encodeUrlPhoto(url){
    return (url.replace(/ /g, '%20')).replace(/[()]/g, (char) => {return char === '(' ? '%28' : '%29'})
}
export {
    isNotNull,
    isSuccess,
    dateIsValid,
    addDays,
    subtractDays,
    convertTimeStamp,
    calcolaGiorni,
    mostraPrezzo,
    isNotNullv2,
    getCity,
    getLocazioni,
    encodeUrlPhoto
}